import React, {useRef} from 'react'
import SignaturePad from 'react-signature-canvas'
import {Button, FormControl, Grid, FormHelperText} from '@material-ui/core'
export default function WSignatureField({data, onChange, tabActive}) {
  let sigPad = {}
  const clear = () => {
    sigPad.clear()
  }
  const save = e => {
    let trimmedSignURL = sigPad.getTrimmedCanvas().toDataURL('image/png')
    onChange(
      {
        target: {
          value: trimmedSignURL,
        },
      },
      data.key
    )
  }
  return (
    <>
      <FormControl
        fullWidth
        variant="outlined"
        className="ap-textfield"
        style={{width: 320, border: '1px solid'}}
      >
        <SignaturePad
          canvasProps={{className: ''}}
          ref={ref => {
            sigPad = ref
          }}
        />
        <Grid container>
          <Grid item xs={6}>
            <Button onClick={clear}>Clear</Button>
          </Grid>
          <Grid item xs={6}>
            <Button onClick={save}>Save</Button>
          </Grid>
        </Grid>
      </FormControl>
      <FormHelperText>
        {(() => {
          if (
            (tabActive === 'upcoming' && data.is_required) ||
            (tabActive === 'ongoing' && data.is_required_return)
          ) {
            return 'required*'
          } else {
            return 'optional'
          }
        })()}
      </FormHelperText>
    </>
  )
}
